import { gql } from 'apollo-boost';

export const paged = gql`
  query paged($orgId: ID!, $limit: Int!, $offset: Int!) {
    customField {
      paged(orgId: $orgId, limit: $limit, offset: $offset) {
        results {
          id
          active
          rowVersion
          label
          customFieldTypeId
          customFieldRequirementLevelId
          customFieldVisibilityId
          description
          listItems
        }
        totalCount
      }
    }
  }
`;
export const all = gql`
  query all($orgId: ID!, $includeExpired: Boolean!) {
    customField {
      all(orgId: $orgId, includeExpired: $includeExpired) {
        id
        active
        displayOrder
        maxResponses
        format
        rowVersion
        label
        listItems
        customFieldTypeId
        customFieldRequirementLevelId
        customFieldVisibilityId
        description
        listItems
        stringId
      }
    }
  }
`;
